import React, { useState } from 'react';
import { auth, database } from '../firebase'; // Firebase imports

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // To confirm the password
  const [isEmailFormVisible, setIsEmailFormVisible] = useState(false);
  const [error, setError] = useState('');

  // Encode email to use as the user ID in the database
  const encodeEmail = (email) => {
    return email.replace(/[@.]/g, '_');
  };

  // Handle user registration
  const handleRegister = async (event) => {
    event.preventDefault();
    

    if (password !== confirmPassword) {
        setError('Passwords do not match.');
        return;
      }
  
    try {
      // Create a new user with email and password
      const userCredential = await auth.createUserWithEmailAndPassword(email, password);
      const user = userCredential.user;
      
      // After registration, encode the email to use as a unique user ID in the database
      const userId = encodeEmail(user.email);

      // Create user data in the Firebase Realtime Database
      await database.ref(`users/${userId}`).set({
        balance: 5.00,
        tier: 'Basic',
        nickname: generateRandomNickname(), // Set a random nickname
      });

      // Create the pronounscard folder with default values
      await database.ref(`users/${userId}/pronounscard`).set({
        pronouns: ["053"],
        flags: ["000"],
        timezone: "Demo",
        description: "Default description"
      });

      alert('Registration successful!');
    } catch (err) {
      setError(err.message);
      console.error('Registration Error:', err.message);
    }
  };

  // Generate a random nickname for the user
  const generateRandomNickname = () => {
    const adjectives = [ "Cool", "Bright", "Funny", "Silly", "Swift", "Amazing", "Gorgeous", 
      "Majestic", "Shimmering", "Ancient", "Vibrant", "Fierce", "Radiant", 
      "Serene", "Bold", "Mystic", "Rugged", "Glorious", "Enchanted", "Timeless", 
      "Noble", "Ethereal", "Invincible", "Proud", "Vast", "Eternal", "Sacred", 
      "Brave", "Loyal", "Radiant", "Luminous", "Fiery", "Gentle", "Mighty", 
      "Shadowed", "Fearless", "Intrepid", "Courageous", "Majestic", "Bold", 
      "Divine", "Peaceful", "Jovial", "Gracious", "Whimsical", "Wild", "Endless",
      "Noble", "Daring", "Classic", "Frosted", "Lush", "Seraphic", "Epic", "Gallant", 
      "Impressive", "Supreme", "Stunning", "Majestic", "Wild", "Boundless", "Vivid"];
    const nouns = ["Panda", "Tiger", "Eagle", "Shark", "Fox", "Bombay", "Zion", "Temasek", 
"Hindustan", "Horizon", "Empire", "Kingdom", "Valley", "Dawn", "Majesty", 
"Spirit", "Legacy", "Realm", "Dynasty", "Peak", "Summit", "Revolution", 
"Glory", "Journey", "Fortress", "Land", "Triumph", "Heritage", "Lion", 
"Dragon", "Temple", "Venture", "Quest", "Courage", "Phoenix", "Galaxy", 
"Wings", "Inferno", "Thunder", "Storm", "Wolf", "Raven", "Vortex", "Mirage", 
"Legion", "Titan", "Tide", "Canyon", "Vanguard", "Maverick", "Odyssey", 
"Falcon", "Skyline", "Venture", "Chasm", "Valor", "Legend", "Vortex", 
"Colossus", "Expanse", "Haven", "Warden", "Eclipse", "Ridge", "Bastion", 
"Titan", "Seeker", "Stratus", "Ember", "Cinder", "Rogue", "Knight", "Sage", 
"Beacon", "Inferno", "Nebula", "Warden", "Fortitude", "Seraph", "Shroud", 
"Glory", "Spectre", "Titan", "Phantom", "Bastion", "Horizon", "Gale", "Dusk"];
    const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
    return `${randomAdjective}${randomNoun}${Math.floor(Math.random() * 10000)}`; // e.g., "CoolTiger23"
  };

  return (
    <div className="login-container">
    <div className="login-box">
      <h2>EnbyBase Website Registration</h2>
      <button onClick={handleRegister} className="google-button">
        Sign up with Google
      </button>
      <button
        onClick={() => setIsEmailFormVisible(!isEmailFormVisible)}
        className="meaa-button"
      >
        Other Email
      </button>

      {isEmailFormVisible && (
        <form onSubmit={handleRegister} className="loginf-email-login-form">
          <p>*Please enter your email and set a password.</p>
          {error && <div className="error">{error}</div>}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            className="loginf-email-input"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            className="loginf-password-input"
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
            required
            className="loginf-password-input"
          />
          <button type="submit" className="loginf-submit-button">Sign Up</button>
        </form>
      )}
      <p className='ploginpbp'>Already Have Account? Click<a href='/account' style={{textDecorationLine: 'none'}}> Here</a>.</p>
    </div>
  </div>
  );
}

export default Register;
